export default __webpack_public_path__ + "static/cruiselines-carnival-ship-5-9e029c55491f9a8331fb6f47c65dd1e4.jpg";